/**
 * Microsoft Advertising UET Tag with Consent Mode v2
 * Offshore Advantage - Lead Generation Website
 * UET Tag ID: 283029521
 * 
 * Features:
 * - Microsoft's official Consent Mode implementation
 * - Default consent set to 'denied' for GDPR compliance
 * - Updates to 'granted' when user accepts advertising cookies via CookieFirst
 * - Tracks contact form submissions as primary conversion
 */

// ============================================================================
// STEP 1: Load UET Tag Immediately (with consent denied by default)
// ============================================================================

(function (w, d, t, u, o) {
  w[u] = w[u] || [];
  o.ts = new Date().getTime();
  var n = d.createElement(t);
  n.src = 'https://bat.bing.net/bat.js?ti=' + o.ti + ('uetq' != u ? '&q=' + u : '');
  n.async = 1;
  n.onload = n.onreadystatechange = function () {
    var s = this.readyState;
    if (!s || 'loaded' === s || 'complete' === s) {
      o.q = w[u];
      w[u] = new UET(o);
      w[u].push('pageLoad');
      n.onload = n.onreadystatechange = null;
    }
  };
  var i = d.getElementsByTagName(t)[0];
  i.parentNode.insertBefore(n, i);
})(window, document, 'script', 'uetq', { ti: '283029521', enableAutoSpaTracking: true });

// ============================================================================
// STEP 2: Set Default Consent to DENIED (GDPR Compliant)
// ============================================================================

window.uetq = window.uetq || [];
window.uetq.push('consent', 'default', {
  ad_storage: 'denied',
});

// ============================================================================
// STEP 3: Update Consent Based on CookieFirst User Choice
// ============================================================================

function updateMicrosoftConsent(consent) {
  if (!consent || typeof consent !== 'object') {
    return;
  }

  window.uetq = window.uetq || [];

  if (consent.advertising === true) {
    // User accepted advertising cookies - grant consent
    window.uetq.push('consent', 'update', {
      ad_storage: 'granted',
    });
  } else {
    // User denied advertising cookies - keep denied
    window.uetq.push('consent', 'update', {
      ad_storage: 'denied',
    });
  }
}

// Check for existing consent immediately
function checkExistingConsent() {
  // First check if CookieFirst is already available
  if (window.CookieFirst?.consent && typeof window.CookieFirst.consent === 'object') {
    updateMicrosoftConsent(window.CookieFirst.consent);
    return true;
  }

  // Then check stored consent in localStorage
  try {
    const storedConsent = localStorage.getItem('cf_consent');
    if (storedConsent) {
      const consentObj = JSON.parse(storedConsent);
      updateMicrosoftConsent(consentObj);
      return true;
    }
  } catch (e) {
    // Silent fail - consent will remain 'denied' by default
  }

  return false;
}

// Check immediately when script loads
checkExistingConsent();

// Also check on DOMContentLoaded
document.addEventListener('DOMContentLoaded', function () {
  checkExistingConsent();
});

// Listen for CookieFirst consent changes
window.addEventListener('cf_consent', function (e) {
  if (e.detail && typeof e.detail === 'object') {
    updateMicrosoftConsent(e.detail);
  }
});

// Listen for CookieFirst initialization
window.addEventListener('cf_init', function () {
  if (window.CookieFirst?.consent && typeof window.CookieFirst.consent === 'object') {
    updateMicrosoftConsent(window.CookieFirst.consent);
  }
});

// ============================================================================
// CONVERSION TRACKING - Contact Form Submission
// ============================================================================

function trackContactFormConversion() {
  // Only track if UET tag is loaded
  if (!window.uetq) {
    console.log('Microsoft Ads: UET tag not loaded yet');
    return;
  }

  // Get form data for enhanced conversion tracking
  const form = document.querySelector('#ContactForm');
  if (!form) {
    console.log('Microsoft Ads: Contact form not found');
    return;
  }

  const formData = new FormData(form);
  
  // Extract form values
  const email = formData.get('contact[email]') || form.querySelector('[name*="email"]')?.value || '';
  const phone = formData.get('contact[phone]') || form.querySelector('[name*="phone"]')?.value || '';
  const firstName = formData.get('contact[first_name]') || form.querySelector('[name*="first"]')?.value || '';
  const lastName = formData.get('contact[last_name]') || form.querySelector('[name*="last"]')?.value || '';
  const industry = form.querySelector('[name*="industry"]')?.value || '';
  const outsourcing = form.querySelector('[name*="outsource"]')?.value || '';

  // STEP 1: Set Enhanced Conversion Data (email, phone, name)
  // This improves conversion tracking accuracy by matching users across devices
  if (email || phone) {
    const enhancedData = {};
    
    if (email) enhancedData.em = email;
    if (phone) enhancedData.ph = phone;
    if (firstName) enhancedData.fn = firstName;
    if (lastName) enhancedData.ln = lastName;
    
    window.uetq.push('set', { 
      'pid': enhancedData
    });
  }

  // STEP 2: Send conversion event to Microsoft Ads
  window.uetq.push('event', 'submit_lead_form', {
    event_category: 'Lead',
    event_label: 'Contact Form Submission',
    event_value: 100.00,
    revenue_value: 100.00,
    currency: 'ZAR'
  });

  // Optional: Log for debugging (remove in production if needed)
  console.log('Microsoft Ads: Contact form conversion tracked with enhanced data');
}

// Setup form tracking
function setupFormTracking() {
  const contactForm = document.querySelector('#ContactForm');
  if (!contactForm) return;

  // Track immediately on form submission (before page reloads)
  contactForm.addEventListener('submit', function(e) {
    // Fire tracking immediately - no delay
    // The form will still submit after this runs
    trackContactFormConversion();
  });
}

// Initialize form tracking
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', setupFormTracking);
} else {
  setupFormTracking();
}

// Re-initialize for Shopify theme editor section loads
document.addEventListener('shopify:section:load', setupFormTracking);